import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PropertyLoan from './pages/PropertyLoan';
import PersonalLoan from './pages/PersonalLoan';
import SharesLoan from './pages/SharesLoan';
import InvoiceDiscounting from './pages/InvoiceDiscounting';
import UsedVehicleLoan from './pages/UsedVehicleLoan';
import MSMELoan from './pages/MSMELoan';
import BecomePartner from './pages/BecomePartner';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Policies from './pages/Policies';
import DLAs from './pages/DLAs';
import AntiMoneyLaundering from './pages/AntiMoneyLaundering';
import FairPracticeCode from './pages/FairPracticeCode';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="main-content">
            <Routes>
              {/* Home Page */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              
              {/* About Page */}
              <Route path="/about" element={<About />} />
              <Route path="/about-us" element={<About />} />
              
              {/* Contact Page */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact-us" element={<Contact />} />
              
              {/* Loan Pages */}
              <Route path="/loans" element={<div className="placeholder-page"><h1>Loans Page</h1><p>Coming Soon...</p></div>} />
              <Route path="/loans/property" element={<PropertyLoan />} />
              <Route path="/loans/personal" element={<PersonalLoan />} />
              <Route path="/loans/shares" element={<SharesLoan />} />
              <Route path="/loans/used-vehicle" element={<UsedVehicleLoan />} />
              <Route path="/loans/invoice-discounting" element={<InvoiceDiscounting />} />
              <Route path="/loans/msme" element={<MSMELoan />} />
              
              {/* Partner Page */}
              <Route path="/partner" element={<BecomePartner />} />
              <Route path="/become-partner" element={<BecomePartner />} />
              <Route path="/become-a-partner" element={<BecomePartner />} />
              
              {/* Privacy Policy Page */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              
              {/* Terms & Conditions Page */}
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/terms-and-conditions" element={<TermsConditions />} />
              
              {/* Policies Page */}
              <Route path="/policies" element={<Policies />} />
              <Route path="/policies/" element={<Policies />} />
              <Route path="/policies/anti-money-laundering" element={<AntiMoneyLaundering />} />
              <Route path="/policies/fair-practice-code" element={<FairPracticeCode />} />
              
              {/* DLA Page */}
              <Route path="/dlas" element={<DLAs />} />
              <Route path="/dlas/" element={<DLAs />} />
            </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
